/** Account page: shows the signed-in email and a change-password form. */
import { useState, type FormEvent } from "react";
import { useChangePassword } from "../../api/auth";
import { useAuth } from "../AuthProvider";
import { PageShell } from "../PageShell";
import { Button, FormError, TextField, apiErrorMessage } from "../../components/ui";

export function AccountPage() {
  const { user } = useAuth();
  const change = useChangePassword();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [done, setDone] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setDone(false);
    try {
      await change.mutateAsync({ currentPassword: current, newPassword: next });
      setDone(true);
      setCurrent("");
      setNext("");
    } catch {
      /* error rendered below */
    }
  }

  return (
    <PageShell>
      <h1 className="font-display text-fluid-xl font-semibold text-ink">Account</h1>
      <p className="mt-1 text-ink-600">{user?.email}</p>

      <form onSubmit={submit} className="mt-6 flex max-w-md flex-col gap-4">
        <h2 className="t-overline text-ink-500">Change password</h2>
        <TextField label="Current password" name="current" type="password" required value={current} onChange={(e) => setCurrent(e.target.value)} autoComplete="current-password" />
        <TextField label="New password" name="next" type="password" required minLength={8} value={next} onChange={(e) => setNext(e.target.value)} autoComplete="new-password" />
        {change.error && <FormError>{apiErrorMessage(change.error)}</FormError>}
        {done && (
          <p className="rounded-sm border border-[var(--color-tier-best)] bg-[color-mix(in_oklab,var(--success)_8%,white)] px-3 py-2 text-sm text-[var(--success)]">
            Password updated.
          </p>
        )}
        <Button type="submit" disabled={change.isPending}>
          {change.isPending ? "Saving…" : "Update password"}
        </Button>
      </form>
    </PageShell>
  );
}
